import FetchByObjectConfig from '../Helpers/FetchByObjectConfig';

export const saveGoogleDriveConfigRequest= (body) => {
    const config = {
        path: 'GoogleDrive',
        method: 'POST',
        body
    };
    return FetchByObjectConfig(config);
}

export const getGoogleDriveConfigRequest= () => {
    const config = {
        path: 'googledrive',
        method: 'GET'
    };
    return FetchByObjectConfig(config);
}

export const revokeGoogleDriveRequest= () => {
    const config = {
        path: 'googledrive',
        method: 'DELETE'
    };
    return FetchByObjectConfig(config);
} 